import PageContainer from '../PageContainer/PageContainer';

type MainProps = {
  children?: React.ReactNode;
  className?: string;
};

const Main = ({ children, className, ...props }: MainProps) => {
  return (
    <main className="flex-1 w-full" {...props}>
      <PageContainer className="h-full">{children}</PageContainer>
    </main>
  );
};

export default Main;
